// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3ffa2c66]{display:none}@media(min-width:768px){.text-section-wrapper[data-v-3ffa2c66]{font-size:18px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
